/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getTickets = /* GraphQL */ `
  query GetTickets($id: ID!) {
    getTickets(id: $id) {
      id
      fechaDeTicket
      horaApertura
      fechaDeAtendido
      horaAtendido
      nombreSolicitante
      numero
      modulo
      titulo
      descripcion
      estatus
      asignadoA
      tipo
      prioridad
      comentariosUsuario
      RespuestaSoporte
      comentariosSoporte
      activo
      archivo
      image
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTickets = /* GraphQL */ `
  query ListTickets(
    $filter: ModelTicketsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTickets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        fechaDeTicket
        horaApertura
        fechaDeAtendido
        horaAtendido
        nombreSolicitante
        numero
        modulo
        titulo
        descripcion
        estatus
        asignadoA
        tipo
        prioridad
        comentariosUsuario
        RespuestaSoporte
        comentariosSoporte
        activo
        archivo
        image
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTicketStatus = /* GraphQL */ `
  query GetTicketStatus($id: ID!) {
    getTicketStatus(id: $id) {
      id
      ticketsID
      numero
      fecha
      hora
      campoModificado
      valorAnterior
      valorActual
      cambioSoporte
      cambioUsuario
      respuestaUsuario
      respuestaSoporte
      usuario
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTicketStatuses = /* GraphQL */ `
  query ListTicketStatuses(
    $filter: ModelTicketStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTicketStatuses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ticketsID
        numero
        fecha
        hora
        campoModificado
        valorAnterior
        valorActual
        cambioSoporte
        cambioUsuario
        respuestaUsuario
        respuestaSoporte
        usuario
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNotificaciones = /* GraphQL */ `
  query GetNotificaciones($id: ID!) {
    getNotificaciones(id: $id) {
      id
      modulo
      Accion
      notificacion
      fecha
      hora
      leido
      usuarioDe
      usuarioPara
      paraSoporte
      recibaSerialID
      tipo
      notifInicialID
      autorizacion
      autorizacionID
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNotificaciones = /* GraphQL */ `
  query ListNotificaciones(
    $filter: ModelNotificacionesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotificaciones(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        modulo
        Accion
        notificacion
        fecha
        hora
        leido
        usuarioDe
        usuarioPara
        paraSoporte
        recibaSerialID
        tipo
        notifInicialID
        autorizacion
        autorizacionID
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNotificacionesNuevas = /* GraphQL */ `
  query GetNotificacionesNuevas($id: ID!) {
    getNotificacionesNuevas(id: $id) {
      id
      NotificacionID
      modulo
      Accion
      notificacion
      fecha
      hora
      leido
      usuarioDe
      usuarioPara
      paraSoporte
      recibaSerialID
      tipo
      notifInicialID
      autorizacion
      autorizacionID
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNotificacionesNuevas = /* GraphQL */ `
  query ListNotificacionesNuevas(
    $filter: ModelNotificacionesNuevasFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotificacionesNuevas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        NotificacionID
        modulo
        Accion
        notificacion
        fecha
        hora
        leido
        usuarioDe
        usuarioPara
        paraSoporte
        recibaSerialID
        tipo
        notifInicialID
        autorizacion
        autorizacionID
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProducto = /* GraphQL */ `
  query GetProducto($id: ID!) {
    getProducto(id: $id) {
      id
      clienteID
      cotizacionID
      piezasXRack
      rackTipo
      numerodeParte
      numerodeParteSalida
      clienteAsociadoID
      numerodeParteAsociado
      sporNP
      poEmbarques
      descripcion
      divisa
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      cantidadporAnio
      documentodeEspecificaciones
      documento1
      documento2
      documento3
      documento4
      documento5
      documento6
      documento7
      documento8
      documento9
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      image1
      image2
      image3
      image4
      image5
      image6
      image7
      image8
      image9
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProductos = /* GraphQL */ `
  query ListProductos(
    $filter: ModelProductoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clienteID
        cotizacionID
        piezasXRack
        rackTipo
        numerodeParte
        numerodeParteSalida
        clienteAsociadoID
        numerodeParteAsociado
        sporNP
        poEmbarques
        descripcion
        divisa
        Pcoat
        Ecoat
        Platinado
        precioUnitario
        precioUnitarioP
        precioUnitarioPC
        cantidadporAnio
        documentodeEspecificaciones
        documento1
        documento2
        documento3
        documento4
        documento5
        documento6
        documento7
        documento8
        documento9
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        image
        image1
        image2
        image3
        image4
        image5
        image6
        image7
        image8
        image9
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCliente = /* GraphQL */ `
  query GetCliente($id: ID!) {
    getCliente(id: $id) {
      id
      cliente
      activo
      descripcion
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      facturaTipo
      requiereIVA
      porcentajeIVA
      rfc
      razonSocial
      usoCFDI
      billTo
      shipTo
      telefono
      correo
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      nombreContacto1
      puestoContacto1
      telefonoContacto1
      correoContacto1
      nombreContacto2
      puestoContacto2
      telefonoContacto2
      correoContacto2
      nombreContacto3
      puestoContacto3
      telefonoContacto3
      correoContacto3
      nombreContacto4
      puestoContacto4
      telefonoContacto4
      correoContacto4
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listClientes = /* GraphQL */ `
  query ListClientes(
    $filter: ModelClienteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClientes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cliente
        activo
        descripcion
        domicilio
        colonia
        ciudad
        estado
        pais
        codigoPostal
        facturaTipo
        requiereIVA
        porcentajeIVA
        rfc
        razonSocial
        usoCFDI
        billTo
        shipTo
        telefono
        correo
        nombreContacto
        puestoContacto
        telefonoContacto
        correoContacto
        nombreContacto1
        puestoContacto1
        telefonoContacto1
        correoContacto1
        nombreContacto2
        puestoContacto2
        telefonoContacto2
        correoContacto2
        nombreContacto3
        puestoContacto3
        telefonoContacto3
        correoContacto3
        nombreContacto4
        puestoContacto4
        telefonoContacto4
        correoContacto4
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        image
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getClienteContactos = /* GraphQL */ `
  query GetClienteContactos($id: ID!) {
    getClienteContactos(id: $id) {
      id
      clienteID
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listClienteContactos = /* GraphQL */ `
  query ListClienteContactos(
    $filter: ModelClienteContactosFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClienteContactos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clienteID
        nombreContacto
        puestoContacto
        telefonoContacto
        correoContacto
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProveedores = /* GraphQL */ `
  query GetProveedores($id: ID!) {
    getProveedores(id: $id) {
      id
      Proveedor
      descripcion
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      rfc
      razonSocial
      telefono
      correo
      activo
      autorizado
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProveedores = /* GraphQL */ `
  query ListProveedores(
    $filter: ModelProveedoresFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProveedores(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        Proveedor
        descripcion
        domicilio
        colonia
        ciudad
        estado
        pais
        codigoPostal
        rfc
        razonSocial
        telefono
        correo
        activo
        autorizado
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        image
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProveedorContactos = /* GraphQL */ `
  query GetProveedorContactos($id: ID!) {
    getProveedorContactos(id: $id) {
      id
      proveedorID
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      sucursal
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProveedorContactos = /* GraphQL */ `
  query ListProveedorContactos(
    $filter: ModelProveedorContactosFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProveedorContactos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        proveedorID
        nombreContacto
        puestoContacto
        telefonoContacto
        correoContacto
        sucursal
        domicilio
        colonia
        ciudad
        estado
        pais
        codigoPostal
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getICuarentena = /* GraphQL */ `
  query GetICuarentena($id: ID!) {
    getICuarentena(id: $id) {
      id
      recibaSerialID
      recibaSerialMPID
      lote
      serial
      serialRecibaBTI
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasaRecuperar
      inspeccion
      defecto
      otroDefecto
      mRecuperacion
      otroMRecuperacion
      comentarios
      activo
      fechaIngreso
      horaIngreso
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listICuarentenas = /* GraphQL */ `
  query ListICuarentenas(
    $filter: ModelICuarentenaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listICuarentenas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        recibaSerialID
        recibaSerialMPID
        lote
        serial
        serialRecibaBTI
        piezasAEmbarcar
        piezasenAlmacen
        piezasenCuarentena
        piezasaRecuperar
        inspeccion
        defecto
        otroDefecto
        mRecuperacion
        otroMRecuperacion
        comentarios
        activo
        fechaIngreso
        horaIngreso
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUbicacion = /* GraphQL */ `
  query GetUbicacion($id: ID!) {
    getUbicacion(id: $id) {
      id
      recibaID
      RecibaSerialesID
      recibaSerialMPID
      fechaDeReciba
      ubicaciondeReciba
      lote
      serial
      serialRecibaBTI
      cantidad
      ubicacion
      locacion
      espacioOcupado
      mesaInspeccion
      comentarios
      activo
      orden
      fechaIngreso
      horaIngreso
      fechaSalida
      horaSalida
      ultimo
      ultimoAnterior
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUbicacions = /* GraphQL */ `
  query ListUbicacions(
    $filter: ModelUbicacionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUbicacions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        recibaID
        RecibaSerialesID
        recibaSerialMPID
        fechaDeReciba
        ubicaciondeReciba
        lote
        serial
        serialRecibaBTI
        cantidad
        ubicacion
        locacion
        espacioOcupado
        mesaInspeccion
        comentarios
        activo
        orden
        fechaIngreso
        horaIngreso
        fechaSalida
        horaSalida
        ultimo
        ultimoAnterior
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getReciba = /* GraphQL */ `
  query GetReciba($id: ID!) {
    getReciba(id: $id) {
      id
      numero
      serialesID
      clienteID
      cliente
      fechaDeReciba
      horaDeReciba
      dueDate
      cantidadRecibida
      po
      status
      quienInspecciono
      comentarios
      packings
      lotes
      LoteBTI
      numerosdeParte
      descripcionesNP
      contenedores
      seriales
      serialesBTI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRecibas = /* GraphQL */ `
  query ListRecibas(
    $filter: ModelRecibaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecibas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        numero
        serialesID
        clienteID
        cliente
        fechaDeReciba
        horaDeReciba
        dueDate
        cantidadRecibida
        po
        status
        quienInspecciono
        comentarios
        packings
        lotes
        LoteBTI
        numerosdeParte
        descripcionesNP
        contenedores
        seriales
        serialesBTI
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRecibaSeriales = /* GraphQL */ `
  query GetRecibaSeriales($id: ID!) {
    getRecibaSeriales(id: $id) {
      id
      numero
      serialRecibaBTI
      recibaSerialMPID
      sporNP
      krecibaNP
      autNoFIFO
      autPNoFIFO1
      autPNoFIFO2
      autPPNoFIFOComentTIOA1
      autPPNoFIFOComentTIOA2
      solNoFIFO
      solNoFIFOModulo
      solPNoFIFOMotivos
      autPNoFIFOComentTIOA
      clienteID
      cliente
      fechaDeReciba
      fechayHoraDeReciba
      MFGFecha
      eViajeraImpresas
      eEmbarquesImpresas
      materialEn
      materialEnCantidad
      empaquesAEmbarcar
      empaquesEmbarcados
      packing
      packingindex
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      numerodeParte
      numerodeParteSalida
      poEmbarques
      piezasXRack
      rackTipo
      descripcion
      cantidadporParte
      recibaID
      lote
      peso
      po
      sombreado
      serial
      cantidadRecibida
      cantidadRecibidaOriginal
      ultimaUbicacion
      rubicaciones
      ubicacion
      locacion
      espacioOcupado
      fechaDeUbicacion
      horaDeUbicacion
      defectoCuarentena
      cantidadPlaneada
      cantidadPlaneadaPC
      piezasPintadasExtra
      piezasPintadas
      piezasPintadasPC
      PiezasEPintadas
      PiezasEPintadasPC
      PiezasENRecuperadas
      PiezasENRecuperadasPC
      piezasEmbarcadas
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasenCarga
      piezasenCargaPC
      piezasenPintado
      piezasenPintadoPC
      piezasInspeccion
      piezasCalidad
      piezasInspeccionPC
      piezasNoAceptadas
      piezasCalidadPC
      piezasNoAceptadasPC
      piezasIRecuperacion
      piezasCRecuperacion
      PiezasCtnaRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      piezasNRecuperadasPC
      piezasCtnaRecuperadas
      piezasCtnaNRecuperadas
      piezasCtnaNAEmbarcar
      piezasCtnaEmbarcadas
      piezasCtnaPintadas
      piezasCtnaPintadasPC
      piezasFacturadas
      facturacionSEID
      MesasInspeccion
      cUnaInspeccion
      racks
      ciclos
      ultimoRack
      numeroCarga
      racksPC
      ciclosPC
      ultimoRackPC
      numeroCargaPC
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      noAceptadasFechaHoraPC
      cargaFechaHoraPC
      pintadoFechaHoraPC
      calidadFechaHoraPC
      registroCarga
      registroCargaPC
      registroPintado
      registroPintadoPC
      registroInspeccionF
      registroInspeccionFPC
      empaqueSinDanos
      materialCorrecto
      materialNContaminado
      materialSinDefectosOvios
      usuarioIncoming
      pruebaSolubilidad
      espesor
      omitirCarga
      omitirCargaComent
      omitirPintado
      omitirPintadoComent
      omitirIFinal
      omitirIFinalComent
      orden
      status
      UltimaInspeccionCuarentena
      quienInspecciono
      comentariosdeinspeccion
      comentariosdecuarentena
      piezasEnPlanta
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRecibaSeriales = /* GraphQL */ `
  query ListRecibaSeriales(
    $filter: ModelRecibaSerialesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecibaSeriales(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        numero
        serialRecibaBTI
        recibaSerialMPID
        sporNP
        krecibaNP
        autNoFIFO
        autPNoFIFO1
        autPNoFIFO2
        autPPNoFIFOComentTIOA1
        autPPNoFIFOComentTIOA2
        solNoFIFO
        solNoFIFOModulo
        solPNoFIFOMotivos
        autPNoFIFOComentTIOA
        clienteID
        cliente
        fechaDeReciba
        fechayHoraDeReciba
        MFGFecha
        eViajeraImpresas
        eEmbarquesImpresas
        materialEn
        materialEnCantidad
        empaquesAEmbarcar
        empaquesEmbarcados
        packing
        packingindex
        productoID
        Pcoat
        Ecoat
        Platinado
        precioUnitario
        precioUnitarioP
        precioUnitarioPC
        divisa
        numerodeParte
        numerodeParteSalida
        poEmbarques
        piezasXRack
        rackTipo
        descripcion
        cantidadporParte
        recibaID
        lote
        peso
        po
        sombreado
        serial
        cantidadRecibida
        cantidadRecibidaOriginal
        ultimaUbicacion
        rubicaciones
        ubicacion
        locacion
        espacioOcupado
        fechaDeUbicacion
        horaDeUbicacion
        defectoCuarentena
        cantidadPlaneada
        cantidadPlaneadaPC
        piezasPintadasExtra
        piezasPintadas
        piezasPintadasPC
        PiezasEPintadas
        PiezasEPintadasPC
        PiezasENRecuperadas
        PiezasENRecuperadasPC
        piezasEmbarcadas
        piezasAEmbarcar
        piezasenAlmacen
        piezasenCuarentena
        piezasenCarga
        piezasenCargaPC
        piezasenPintado
        piezasenPintadoPC
        piezasInspeccion
        piezasCalidad
        piezasInspeccionPC
        piezasNoAceptadas
        piezasCalidadPC
        piezasNoAceptadasPC
        piezasIRecuperacion
        piezasCRecuperacion
        PiezasCtnaRecuperacion
        piezasTRecuperacion
        piezasRecuperadas
        piezasNRecuperadas
        piezasNRecuperadasPC
        piezasCtnaRecuperadas
        piezasCtnaNRecuperadas
        piezasCtnaNAEmbarcar
        piezasCtnaEmbarcadas
        piezasCtnaPintadas
        piezasCtnaPintadasPC
        piezasFacturadas
        facturacionSEID
        MesasInspeccion
        cUnaInspeccion
        racks
        ciclos
        ultimoRack
        numeroCarga
        racksPC
        ciclosPC
        ultimoRackPC
        numeroCargaPC
        cargaFechaHora
        pintadoFechaHora
        inspeccionesFechaHora
        recuperacionICFechaHora
        calidadFechaHora
        noAceptadasFechaHora
        noAceptadasFechaHoraPC
        cargaFechaHoraPC
        pintadoFechaHoraPC
        calidadFechaHoraPC
        registroCarga
        registroCargaPC
        registroPintado
        registroPintadoPC
        registroInspeccionF
        registroInspeccionFPC
        empaqueSinDanos
        materialCorrecto
        materialNContaminado
        materialSinDefectosOvios
        usuarioIncoming
        pruebaSolubilidad
        espesor
        omitirCarga
        omitirCargaComent
        omitirPintado
        omitirPintadoComent
        omitirIFinal
        omitirIFinalComent
        orden
        status
        UltimaInspeccionCuarentena
        quienInspecciono
        comentariosdeinspeccion
        comentariosdecuarentena
        piezasEnPlanta
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRecibaSerialesMP = /* GraphQL */ `
  query GetRecibaSerialesMP($id: ID!) {
    getRecibaSerialesMP(id: $id) {
      id
      recibaSerialID
      rsUpdatedAt
      sporNP
      krecibaNP
      numero
      serialRecibaBTI
      autNoFIFO
      autPNoFIFO1
      autPNoFIFO2
      autPPNoFIFOComentTIOA1
      autPPNoFIFOComentTIOA2
      solNoFIFO
      solNoFIFOModulo
      solPNoFIFOMotivos
      autPNoFIFOComentTIOA
      clienteID
      cliente
      fechaDeReciba
      fechayHoraDeReciba
      MFGFecha
      eViajeraImpresas
      eEmbarquesImpresas
      materialEn
      materialEnCantidad
      empaquesAEmbarcar
      empaquesEmbarcados
      packing
      packingindex
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      numerodeParte
      numerodeParteSalida
      poEmbarques
      piezasXRack
      rackTipo
      descripcion
      cantidadporParte
      recibaID
      lote
      peso
      po
      sombreado
      serial
      cantidadRecibida
      cantidadRecibidaOriginal
      ultimaUbicacion
      rubicaciones
      ubicacion
      locacion
      espacioOcupado
      fechaDeUbicacion
      horaDeUbicacion
      defectoCuarentena
      cantidadPlaneada
      cantidadPlaneadaPC
      piezasPintadasExtra
      piezasPintadas
      piezasPintadasPC
      PiezasEPintadas
      PiezasEPintadasPC
      PiezasENRecuperadas
      PiezasENRecuperadasPC
      piezasEmbarcadas
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasenCarga
      piezasenCargaPC
      piezasenPintado
      piezasenPintadoPC
      piezasInspeccion
      piezasCalidad
      piezasInspeccionPC
      piezasCalidadPC
      piezasNoAceptadasPC
      piezasNoAceptadas
      piezasIRecuperacion
      piezasCRecuperacion
      PiezasCtnaRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      piezasNRecuperadasPC
      piezasCtnaRecuperadas
      piezasCtnaNRecuperadas
      piezasCtnaNAEmbarcar
      piezasCtnaEmbarcadas
      piezasCtnaPintadas
      piezasCtnaPintadasPC
      piezasFacturadas
      facturacionSEID
      MesasInspeccion
      cUnaInspeccion
      racks
      ciclos
      ultimoRack
      numeroCarga
      racksPC
      ciclosPC
      ultimoRackPC
      numeroCargaPC
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      noAceptadasFechaHoraPC
      cargaFechaHoraPC
      pintadoFechaHoraPC
      calidadFechaHoraPC
      registroCarga
      registroCargaPC
      registroPintado
      registroPintadoPC
      registroInspeccionF
      registroInspeccionFPC
      empaqueSinDanos
      materialCorrecto
      materialNContaminado
      materialSinDefectosOvios
      usuarioIncoming
      pruebaSolubilidad
      espesor
      omitirCarga
      omitirCargaComent
      omitirPintado
      omitirPintadoComent
      omitirIFinal
      omitirIFinalComent
      orden
      status
      UltimaInspeccionCuarentena
      quienInspecciono
      comentariosdeinspeccion
      comentariosdecuarentena
      piezasEnPlanta
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRecibaSerialesMPS = /* GraphQL */ `
  query ListRecibaSerialesMPS(
    $filter: ModelRecibaSerialesMPFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecibaSerialesMPS(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        recibaSerialID
        rsUpdatedAt
        sporNP
        krecibaNP
        numero
        serialRecibaBTI
        autNoFIFO
        autPNoFIFO1
        autPNoFIFO2
        autPPNoFIFOComentTIOA1
        autPPNoFIFOComentTIOA2
        solNoFIFO
        solNoFIFOModulo
        solPNoFIFOMotivos
        autPNoFIFOComentTIOA
        clienteID
        cliente
        fechaDeReciba
        fechayHoraDeReciba
        MFGFecha
        eViajeraImpresas
        eEmbarquesImpresas
        materialEn
        materialEnCantidad
        empaquesAEmbarcar
        empaquesEmbarcados
        packing
        packingindex
        productoID
        Pcoat
        Ecoat
        Platinado
        precioUnitario
        precioUnitarioP
        precioUnitarioPC
        divisa
        numerodeParte
        numerodeParteSalida
        poEmbarques
        piezasXRack
        rackTipo
        descripcion
        cantidadporParte
        recibaID
        lote
        peso
        po
        sombreado
        serial
        cantidadRecibida
        cantidadRecibidaOriginal
        ultimaUbicacion
        rubicaciones
        ubicacion
        locacion
        espacioOcupado
        fechaDeUbicacion
        horaDeUbicacion
        defectoCuarentena
        cantidadPlaneada
        cantidadPlaneadaPC
        piezasPintadasExtra
        piezasPintadas
        piezasPintadasPC
        PiezasEPintadas
        PiezasEPintadasPC
        PiezasENRecuperadas
        PiezasENRecuperadasPC
        piezasEmbarcadas
        piezasAEmbarcar
        piezasenAlmacen
        piezasenCuarentena
        piezasenCarga
        piezasenCargaPC
        piezasenPintado
        piezasenPintadoPC
        piezasInspeccion
        piezasCalidad
        piezasInspeccionPC
        piezasCalidadPC
        piezasNoAceptadasPC
        piezasNoAceptadas
        piezasIRecuperacion
        piezasCRecuperacion
        PiezasCtnaRecuperacion
        piezasTRecuperacion
        piezasRecuperadas
        piezasNRecuperadas
        piezasNRecuperadasPC
        piezasCtnaRecuperadas
        piezasCtnaNRecuperadas
        piezasCtnaNAEmbarcar
        piezasCtnaEmbarcadas
        piezasCtnaPintadas
        piezasCtnaPintadasPC
        piezasFacturadas
        facturacionSEID
        MesasInspeccion
        cUnaInspeccion
        racks
        ciclos
        ultimoRack
        numeroCarga
        racksPC
        ciclosPC
        ultimoRackPC
        numeroCargaPC
        cargaFechaHora
        pintadoFechaHora
        inspeccionesFechaHora
        recuperacionICFechaHora
        calidadFechaHora
        noAceptadasFechaHora
        noAceptadasFechaHoraPC
        cargaFechaHoraPC
        pintadoFechaHoraPC
        calidadFechaHoraPC
        registroCarga
        registroCargaPC
        registroPintado
        registroPintadoPC
        registroInspeccionF
        registroInspeccionFPC
        empaqueSinDanos
        materialCorrecto
        materialNContaminado
        materialSinDefectosOvios
        usuarioIncoming
        pruebaSolubilidad
        espesor
        omitirCarga
        omitirCargaComent
        omitirPintado
        omitirPintadoComent
        omitirIFinal
        omitirIFinalComent
        orden
        status
        UltimaInspeccionCuarentena
        quienInspecciono
        comentariosdeinspeccion
        comentariosdecuarentena
        piezasEnPlanta
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAutorizaciones = /* GraphQL */ `
  query GetAutorizaciones($id: ID!) {
    getAutorizaciones(id: $id) {
      id
      recibaSerialID
      recibaSerialMPID
      clienteID
      cliente
      productoID
      numerodeParte
      descripcion
      serial
      autoNumero
      serialRecibaBTI
      peticionTipo
      peticionModulo
      peticionMotivos
      peticionFecha
      peticionHora
      peticionUsuario
      peticionUAutorizar
      resolucion
      resolucionUsuario
      resolucionComentarios
      resolucionFecha
      resolucionHora
      cancelado
      cancelacionComentarios
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAutorizaciones = /* GraphQL */ `
  query ListAutorizaciones(
    $filter: ModelAutorizacionesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAutorizaciones(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        recibaSerialID
        recibaSerialMPID
        clienteID
        cliente
        productoID
        numerodeParte
        descripcion
        serial
        autoNumero
        serialRecibaBTI
        peticionTipo
        peticionModulo
        peticionMotivos
        peticionFecha
        peticionHora
        peticionUsuario
        peticionUAutorizar
        resolucion
        resolucionUsuario
        resolucionComentarios
        resolucionFecha
        resolucionHora
        cancelado
        cancelacionComentarios
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRecuperacion = /* GraphQL */ `
  query GetRecuperacion($id: ID!) {
    getRecuperacion(id: $id) {
      id
      recibaSerialID
      recibaSerialMPID
      pProduccionID
      clienteID
      cliente
      productoID
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      cantidad
      cantidadLiberada
      piezasRecuperadas
      piezasNRecuperadas
      UbicacionDeIngreso
      LocacionDeIngreso
      ingresadoPorArea
      ingresadoPorUsuario
      mesaInspeccion
      defecto
      otroDefecto
      mRecuperacion
      otroMRecuperacion
      comentariosInspeccion
      comentariosRecuperacion
      ultimaInspeccion
      Revision1Inspector
      Revision1Comentarios
      Revision1CAprobado
      Revision1CALiberada
      Revision1CNAprobado
      Revision1CNALiberada
      Revision1MRecuperacion
      Revision2Inspector
      Revision2Comentarios
      Revision2CAprobado
      Revision2CALiberado
      Revision2CNAprobado
      Revision2CNALiberado
      Revision2MRecuperacion
      Revision3Inspector
      Revision3Comentarios
      Revision3CAprobado
      Revision3CALiberado
      Revision3CNAprobado
      Revision3CNALiberado
      Revision3MRecuperacion
      Revision4Inspector
      Revision4Comentarios
      Revision4CAprobado
      Revision4CALiberado
      Revision4CNAprobado
      Revision4CNALiberado
      Revision4MRecuperacion
      Revision5Inspector
      Revision5Comentarios
      Revision5CAprobado
      Revision5CALiberado
      Revision5CNAprobado
      Revision5CNALiberado
      Revision5MRecuperacion
      activo
      fechaIngreso
      horaIngreso
      fechaEntradaReal
      fechaEntrada
      horaEntrada
      ingresadoPor
      fechaSalida
      horaSalida
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRecuperacions = /* GraphQL */ `
  query ListRecuperacions(
    $filter: ModelRecuperacionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecuperacions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        recibaSerialID
        recibaSerialMPID
        pProduccionID
        clienteID
        cliente
        productoID
        numerodeParte
        descripcion
        serial
        serialRecibaBTI
        cantidad
        cantidadLiberada
        piezasRecuperadas
        piezasNRecuperadas
        UbicacionDeIngreso
        LocacionDeIngreso
        ingresadoPorArea
        ingresadoPorUsuario
        mesaInspeccion
        defecto
        otroDefecto
        mRecuperacion
        otroMRecuperacion
        comentariosInspeccion
        comentariosRecuperacion
        ultimaInspeccion
        Revision1Inspector
        Revision1Comentarios
        Revision1CAprobado
        Revision1CALiberada
        Revision1CNAprobado
        Revision1CNALiberada
        Revision1MRecuperacion
        Revision2Inspector
        Revision2Comentarios
        Revision2CAprobado
        Revision2CALiberado
        Revision2CNAprobado
        Revision2CNALiberado
        Revision2MRecuperacion
        Revision3Inspector
        Revision3Comentarios
        Revision3CAprobado
        Revision3CALiberado
        Revision3CNAprobado
        Revision3CNALiberado
        Revision3MRecuperacion
        Revision4Inspector
        Revision4Comentarios
        Revision4CAprobado
        Revision4CALiberado
        Revision4CNAprobado
        Revision4CNALiberado
        Revision4MRecuperacion
        Revision5Inspector
        Revision5Comentarios
        Revision5CAprobado
        Revision5CALiberado
        Revision5CNAprobado
        Revision5CNALiberado
        Revision5MRecuperacion
        activo
        fechaIngreso
        horaIngreso
        fechaEntradaReal
        fechaEntrada
        horaEntrada
        ingresadoPor
        fechaSalida
        horaSalida
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPlaneacionBase = /* GraphQL */ `
  query GetPlaneacionBase($id: ID!) {
    getPlaneacionBase(id: $id) {
      id
      fechaDePlaneacion
      numero
      planeacionGeneralID
      clienteID
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      cliente
      numerodeParte
      descripcion
      cantidadPiezas
      piezasXRack
      rackTipo
      prioridad
      prioridadAtencion
      racks
      ciclos
      materialEn
      materialEnCantidad
      orden
      activo
      comentarios
      comentariosProduccion
      fechaHoraCreacion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPlaneacionBases = /* GraphQL */ `
  query ListPlaneacionBases(
    $filter: ModelPlaneacionBaseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlaneacionBases(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        fechaDePlaneacion
        numero
        planeacionGeneralID
        clienteID
        productoID
        Pcoat
        Ecoat
        Platinado
        precioUnitario
        precioUnitarioP
        precioUnitarioPC
        divisa
        cliente
        numerodeParte
        descripcion
        cantidadPiezas
        piezasXRack
        rackTipo
        prioridad
        prioridadAtencion
        racks
        ciclos
        materialEn
        materialEnCantidad
        orden
        activo
        comentarios
        comentariosProduccion
        fechaHoraCreacion
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getADatosROperacion = /* GraphQL */ `
  query GetADatosROperacion($id: ID!) {
    getADatosROperacion(id: $id) {
      id
      ecCapacidadLinea
      objetivoFacturacion
      metaVentaCumplimientoKPI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listADatosROperacions = /* GraphQL */ `
  query ListADatosROperacions(
    $filter: ModelADatosROperacionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listADatosROperacions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ecCapacidadLinea
        objetivoFacturacion
        metaVentaCumplimientoKPI
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getResumenOperacion = /* GraphQL */ `
  query GetResumenOperacion($id: ID!) {
    getResumenOperacion(id: $id) {
      id
      fecha
      totalInspeccionado
      recibaSerialIDS
      defectuso
      porcentajeDefectuoso
      primerContribuidor
      primerContribuidorNP
      segundoContribuidor
      segundoContribuidorNP
      tercerContribuidor
      tercerContribuidorNP
      sqftProducidos
      gastosQuimicos
      consumoAgua
      costoQuimicoSQFT
      costoQuimicovsFacturacion
      eficienciaCargaRacks
      ecCapacidadLinea
      ecProgramados
      ecCapacidadLineaProgramada
      ecCargados
      ecEFvsPP
      ecEspaciosVacios
      ecPorcentajePerdido
      apFaltaCarga
      apIncapacidadCarga
      apFaltaInspeccion
      apIncapacidadInspeccion
      apFaltaCargaPC
      apIncapacidadCargaPC
      apFaltaInspeccionPC
      apIncapacidadInspeccionPC
      objetivoFacturacion
      metaVentaCumplimientoKPI
      facturacionPlaneada
      facturacion
      facturadoPendientePorEmbarcar
      facturacionTotaldelDia
      diferenciaVSPlaneado
      diferenciaPorcentaje
      materialPendienteporInspeccion
      inventario
      estatusPendientesMejoras
      accionesaTomar
      inventarioOperacion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listResumenOperacions = /* GraphQL */ `
  query ListResumenOperacions(
    $filter: ModelResumenOperacionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResumenOperacions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fecha
        totalInspeccionado
        recibaSerialIDS
        defectuso
        porcentajeDefectuoso
        primerContribuidor
        primerContribuidorNP
        segundoContribuidor
        segundoContribuidorNP
        tercerContribuidor
        tercerContribuidorNP
        sqftProducidos
        gastosQuimicos
        consumoAgua
        costoQuimicoSQFT
        costoQuimicovsFacturacion
        eficienciaCargaRacks
        ecCapacidadLinea
        ecProgramados
        ecCapacidadLineaProgramada
        ecCargados
        ecEFvsPP
        ecEspaciosVacios
        ecPorcentajePerdido
        apFaltaCarga
        apIncapacidadCarga
        apFaltaInspeccion
        apIncapacidadInspeccion
        apFaltaCargaPC
        apIncapacidadCargaPC
        apFaltaInspeccionPC
        apIncapacidadInspeccionPC
        objetivoFacturacion
        metaVentaCumplimientoKPI
        facturacionPlaneada
        facturacion
        facturadoPendientePorEmbarcar
        facturacionTotaldelDia
        diferenciaVSPlaneado
        diferenciaPorcentaje
        materialPendienteporInspeccion
        inventario
        estatusPendientesMejoras
        accionesaTomar
        inventarioOperacion
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPlaneacionBaseGeneral = /* GraphQL */ `
  query GetPlaneacionBaseGeneral($id: ID!) {
    getPlaneacionBaseGeneral(id: $id) {
      id
      fechaDePlaneacion
      PlaneacionBIDS
      comentarios
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPlaneacionBaseGenerals = /* GraphQL */ `
  query ListPlaneacionBaseGenerals(
    $filter: ModelPlaneacionBaseGeneralFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlaneacionBaseGenerals(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fechaDePlaneacion
        PlaneacionBIDS
        comentarios
        numero
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPlaneacion = /* GraphQL */ `
  query GetPlaneacion($id: ID!) {
    getPlaneacion(id: $id) {
      id
      fechaDePlaneacion
      numeroPProduccion
      numero
      recibaSerialID
      recibaSerialMPID
      sporNP
      krecibaNP
      planeacionGeneralID
      clienteID
      productoID
      precioUnitario
      divisa
      cliente
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      locacion
      cantidadPiezas
      piezasXRack
      prioridad
      racks
      ciclos
      cantidadPlanProduccion
      enPlanProduccion
      materialEn
      materialEnCantidad
      orden
      activo
      atrasado
      terminado
      regresadoAlmacen
      piezasTransferidas
      FechaTransferencia
      fechaAnterior
      planeacionIDAnterior
      pProduccionIDAnterior
      fechaHoraCreacion
      desdePproduccion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPlaneacions = /* GraphQL */ `
  query ListPlaneacions(
    $filter: ModelPlaneacionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlaneacions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        fechaDePlaneacion
        numeroPProduccion
        numero
        recibaSerialID
        recibaSerialMPID
        sporNP
        krecibaNP
        planeacionGeneralID
        clienteID
        productoID
        precioUnitario
        divisa
        cliente
        numerodeParte
        descripcion
        serial
        serialRecibaBTI
        locacion
        cantidadPiezas
        piezasXRack
        prioridad
        racks
        ciclos
        cantidadPlanProduccion
        enPlanProduccion
        materialEn
        materialEnCantidad
        orden
        activo
        atrasado
        terminado
        regresadoAlmacen
        piezasTransferidas
        FechaTransferencia
        fechaAnterior
        planeacionIDAnterior
        pProduccionIDAnterior
        fechaHoraCreacion
        desdePproduccion
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPlaneacionGeneral = /* GraphQL */ `
  query GetPlaneacionGeneral($id: ID!) {
    getPlaneacionGeneral(id: $id) {
      id
      fechaDePlaneacion
      PlaneacionIDS
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPlaneacionGenerals = /* GraphQL */ `
  query ListPlaneacionGenerals(
    $filter: ModelPlaneacionGeneralFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlaneacionGenerals(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fechaDePlaneacion
        PlaneacionIDS
        numero
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPProduccion = /* GraphQL */ `
  query GetPProduccion($id: ID!) {
    getPProduccion(id: $id) {
      id
      fechaDePlaneacion
      numero
      numeroPlaneacion
      recibaSerialID
      recibaSerialMPID
      sporNP
      krecibaNP
      PlaneacionID
      pproduccionGeneralID
      clienteID
      productoID
      precioUnitario
      divisa
      cliente
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      locacion
      cantidadPiezas
      piezasXRack
      piezasPintadas
      piezasTransferidas
      FechaTransferencia
      prioridad
      racks
      ciclos
      orden
      materialEn
      materialEnCantidad
      desdeAlmacen
      piezasenCarga
      piezasenPintado
      piezasInspeccion
      piezasCalidad
      piezasNoAceptadas
      pnadefecto
      pnaotroDefecto
      piezasIRecuperacion
      piezasCRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      MesasInspeccion
      racksOriginal
      numeroCarga
      ultimoRack
      cUnaInspeccion
      registroCarga
      registroPintado
      registroInspeccionF
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      piezasenCargaAnterior
      piezasenPintadoAnterior
      piezasInspeccionAnterior
      piezasNoAceptadasAnterior
      piezasenCarga1
      numeroRackCarga1
      racksCarga1
      cicloCarga1
      piezasenCarga2
      numeroRackCarga2
      racksCarga2
      cicloCarga2
      piezasenCarga3
      numeroRackCarga3
      racksCarga3
      cicloCarga3
      piezasenCarga4
      numeroRackCarga4
      racksCarga4
      cicloCarga4
      piezasenCarga5
      numeroRackCarga5
      racksCarga5
      cicloCarga5
      piezasenCarga6
      numeroRackCarga6
      racksCarga6
      cicloCarga6
      piezasenCarga7
      numeroRackCarga7
      racksCarga7
      cicloCarga7
      piezasenCarga8
      numeroRackCarga8
      racksCarga8
      cicloCarga8
      piezasenCarga9
      numeroRackCarga9
      racksCarga9
      cicloCarga9
      piezasenCarga10
      numeroRackCarga10
      racksCarga10
      cicloCarga10
      piezasenCarga11
      numeroRackCarga11
      racksCarga11
      cicloCarga11
      piezasenCarga12
      numeroRackCarga12
      racksCarga12
      cicloCarga12
      piezasenCarga13
      numeroRackCarga13
      racksCarga13
      cicloCarga13
      piezasenCarga14
      numeroRackCarga14
      racksCarga14
      cicloCarga14
      piezasenCarga15
      numeroRackCarga15
      racksCarga15
      cicloCarga15
      piezasenCarga16
      numeroRackCarga16
      racksCarga16
      cicloCarga16
      activo
      terminado
      regresadoAlmacen
      atrasado
      fechaAnterior
      planeacionIDAnterior
      pProduccionIDAnterior
      fechaHoraCreacion
      desdePproduccion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPProduccions = /* GraphQL */ `
  query ListPProduccions(
    $filter: ModelPProduccionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPProduccions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        fechaDePlaneacion
        numero
        numeroPlaneacion
        recibaSerialID
        recibaSerialMPID
        sporNP
        krecibaNP
        PlaneacionID
        pproduccionGeneralID
        clienteID
        productoID
        precioUnitario
        divisa
        cliente
        numerodeParte
        descripcion
        serial
        serialRecibaBTI
        locacion
        cantidadPiezas
        piezasXRack
        piezasPintadas
        piezasTransferidas
        FechaTransferencia
        prioridad
        racks
        ciclos
        orden
        materialEn
        materialEnCantidad
        desdeAlmacen
        piezasenCarga
        piezasenPintado
        piezasInspeccion
        piezasCalidad
        piezasNoAceptadas
        pnadefecto
        pnaotroDefecto
        piezasIRecuperacion
        piezasCRecuperacion
        piezasTRecuperacion
        piezasRecuperadas
        piezasNRecuperadas
        MesasInspeccion
        racksOriginal
        numeroCarga
        ultimoRack
        cUnaInspeccion
        registroCarga
        registroPintado
        registroInspeccionF
        cargaFechaHora
        pintadoFechaHora
        inspeccionesFechaHora
        recuperacionICFechaHora
        calidadFechaHora
        noAceptadasFechaHora
        piezasenCargaAnterior
        piezasenPintadoAnterior
        piezasInspeccionAnterior
        piezasNoAceptadasAnterior
        piezasenCarga1
        numeroRackCarga1
        racksCarga1
        cicloCarga1
        piezasenCarga2
        numeroRackCarga2
        racksCarga2
        cicloCarga2
        piezasenCarga3
        numeroRackCarga3
        racksCarga3
        cicloCarga3
        piezasenCarga4
        numeroRackCarga4
        racksCarga4
        cicloCarga4
        piezasenCarga5
        numeroRackCarga5
        racksCarga5
        cicloCarga5
        piezasenCarga6
        numeroRackCarga6
        racksCarga6
        cicloCarga6
        piezasenCarga7
        numeroRackCarga7
        racksCarga7
        cicloCarga7
        piezasenCarga8
        numeroRackCarga8
        racksCarga8
        cicloCarga8
        piezasenCarga9
        numeroRackCarga9
        racksCarga9
        cicloCarga9
        piezasenCarga10
        numeroRackCarga10
        racksCarga10
        cicloCarga10
        piezasenCarga11
        numeroRackCarga11
        racksCarga11
        cicloCarga11
        piezasenCarga12
        numeroRackCarga12
        racksCarga12
        cicloCarga12
        piezasenCarga13
        numeroRackCarga13
        racksCarga13
        cicloCarga13
        piezasenCarga14
        numeroRackCarga14
        racksCarga14
        cicloCarga14
        piezasenCarga15
        numeroRackCarga15
        racksCarga15
        cicloCarga15
        piezasenCarga16
        numeroRackCarga16
        racksCarga16
        cicloCarga16
        activo
        terminado
        regresadoAlmacen
        atrasado
        fechaAnterior
        planeacionIDAnterior
        pProduccionIDAnterior
        fechaHoraCreacion
        desdePproduccion
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPProduccionGeneral = /* GraphQL */ `
  query GetPProduccionGeneral($id: ID!) {
    getPProduccionGeneral(id: $id) {
      id
      fechaDePlaneacion
      PProduccionIDS
      recibaSerialIDS
      porSerial
      numero
      espacioVacio
      espacioHora
      espacioHistorial
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPProduccionGenerals = /* GraphQL */ `
  query ListPProduccionGenerals(
    $filter: ModelPProduccionGeneralFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPProduccionGenerals(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fechaDePlaneacion
        PProduccionIDS
        recibaSerialIDS
        porSerial
        numero
        espacioVacio
        espacioHora
        espacioHistorial
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmbarque = /* GraphQL */ `
  query GetEmbarque($id: ID!) {
    getEmbarque(id: $id) {
      id
      fechaDeEmbarque
      fechaDeReciba
      serialesEID
      MFGFecha
      numero
      invoiceID
      atencionA
      ordenDeCompra
      clienteID
      cliente
      clienteEntregaID
      clienteEntrega
      facturarA
      numerosdeParte
      totalNumerodeParte
      sinTotalScrap
      sinTotalScrapFactura
      packings
      lotes
      seriales
      piezasEmbarcadas
      piezasPintadas
      piezasPintadasExtra
      piezasNRecuperadas
      piezasNoPintadas
      facturado
      facturaDescuentoP
      fechaDeFacturacion
      billTo
      shipTo
      salesPerson
      PO
      requisitioner
      shippedvia
      dueDate
      casQuote
      comentariosFacturacion
      serviciosExtra
      servicioExtraEmbarques
      desgloceVer
      desgloceVerFacturacion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmbarques = /* GraphQL */ `
  query ListEmbarques(
    $filter: ModelEmbarqueFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmbarques(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        fechaDeEmbarque
        fechaDeReciba
        serialesEID
        MFGFecha
        numero
        invoiceID
        atencionA
        ordenDeCompra
        clienteID
        cliente
        clienteEntregaID
        clienteEntrega
        facturarA
        numerosdeParte
        totalNumerodeParte
        sinTotalScrap
        sinTotalScrapFactura
        packings
        lotes
        seriales
        piezasEmbarcadas
        piezasPintadas
        piezasPintadasExtra
        piezasNRecuperadas
        piezasNoPintadas
        facturado
        facturaDescuentoP
        fechaDeFacturacion
        billTo
        shipTo
        salesPerson
        PO
        requisitioner
        shippedvia
        dueDate
        casQuote
        comentariosFacturacion
        serviciosExtra
        servicioExtraEmbarques
        desgloceVer
        desgloceVerFacturacion
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFacturaConceptoGeneral = /* GraphQL */ `
  query GetFacturaConceptoGeneral($id: ID!) {
    getFacturaConceptoGeneral(id: $id) {
      id
      fechaDeFacturacion
      numero
      invoiceID
      clienteID
      cliente
      billTo
      shipTo
      salesPerson
      PO
      requisitioner
      shippedvia
      dueDate
      casQuote
      facturaDescuentoP
      comentariosFacturacion
      Conceptos
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFacturaConceptoGenerals = /* GraphQL */ `
  query ListFacturaConceptoGenerals(
    $filter: ModelFacturaConceptoGeneralFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFacturaConceptoGenerals(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fechaDeFacturacion
        numero
        invoiceID
        clienteID
        cliente
        billTo
        shipTo
        salesPerson
        PO
        requisitioner
        shippedvia
        dueDate
        casQuote
        facturaDescuentoP
        comentariosFacturacion
        Conceptos
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmbarqueSeriales = /* GraphQL */ `
  query GetEmbarqueSeriales($id: ID!) {
    getEmbarqueSeriales(id: $id) {
      id
      embarqueID
      numero
      invoiceID
      numeroSerial
      fechaDeEmbarque
      fechaDeReciba
      MFGFecha
      atencionA
      ordenDeCompra
      comentarios
      clienteID
      cliente
      clienteEntregaID
      clienteEntrega
      facturarA
      facturado
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      precioUnitarioTot
      divisa
      recibaSerialID
      recibaSerialMPID
      productoID
      numerodeParte
      numerodeParteSalida
      poEmbarques
      descripcion
      desgloceInsercion
      piezasPintadasExtra
      piezasPintadas
      piezasEmbarcadas
      piezasCtnaNRecuperadas
      piezasNoPintadas
      piezasNRecuperadas
      piezasNRecuperadasE
      pNRecuperadasOriginal
      pPintadasOriginal
      packing
      lote
      po
      MaterialPintado
      ambos
      serial
      serialRecibaBTI
      serialNRecuperado
      materialEn
      materialEnCantidad
      orden
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmbarqueSeriales = /* GraphQL */ `
  query ListEmbarqueSeriales(
    $filter: ModelEmbarqueSerialesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmbarqueSeriales(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        embarqueID
        numero
        invoiceID
        numeroSerial
        fechaDeEmbarque
        fechaDeReciba
        MFGFecha
        atencionA
        ordenDeCompra
        comentarios
        clienteID
        cliente
        clienteEntregaID
        clienteEntrega
        facturarA
        facturado
        Pcoat
        Ecoat
        Platinado
        precioUnitario
        precioUnitarioP
        precioUnitarioPC
        precioUnitarioTot
        divisa
        recibaSerialID
        recibaSerialMPID
        productoID
        numerodeParte
        numerodeParteSalida
        poEmbarques
        descripcion
        desgloceInsercion
        piezasPintadasExtra
        piezasPintadas
        piezasEmbarcadas
        piezasCtnaNRecuperadas
        piezasNoPintadas
        piezasNRecuperadas
        piezasNRecuperadasE
        pNRecuperadasOriginal
        pPintadasOriginal
        packing
        lote
        po
        MaterialPintado
        ambos
        serial
        serialRecibaBTI
        serialNRecuperado
        materialEn
        materialEnCantidad
        orden
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCotizacion = /* GraphQL */ `
  query GetCotizacion($id: ID!) {
    getCotizacion(id: $id) {
      id
      CotizacionPadreID
      numero
      quoteNumber
      divisa
      date
      status
      fechaCreado
      fechaAutorizado
      fechaEnviado
      fechaEsperando
      fechaAceptado
      fechaRechazado
      generator
      revision
      processEngineering
      platingProcess
      clienteID
      cliente
      clienteCatalogo
      clienteNContacto
      productoCreado
      productoID
      address
      colonia
      ciudad
      estado
      pais
      codigoPostal
      telefono
      correo
      requestor
      position
      desk
      mobile
      email
      automotive
      OEM
      RFQNumber
      numerodeParte
      descripcion
      nickName
      annualVolume
      packigType
      packingINumber
      packingIRevision
      packingSource
      sampleReceived
      drawingSProvided
      drawingRevision
      paintThickness
      paintSpec
      zincPlating
      chromateColor
      previousProcess
      whiteCRequirement
      RedCRequiremen
      SOP
      EOP
      area
      pieceWeight
      printNotes
      salesNotes
      hangingTool
      asignedToolBar
      rackType
      piecesperBar
      barsPerLevel
      levels
      piecesPerRack
      weightForRack
      totalPerRack
      toolingCost
      maximumPieces
      newToolRequired
      costOfNewTool
      totalWeightRack
      asignedVoltage
      suggestedRack
      processSuggestedPrice
      finalRackSale
      finalSalePrice
      finalSQFTPrice
      typeOfProcess
      hangingToolP
      firstRowDistance
      tPiecesPROB
      pPerlevel
      lPerRack
      toolAngle
      toolingCostP
      SQTFPerBR
      loadWeightK
      DCVoltageA
      DCAmperageA
      residenceTimeZinc
      residenceTimeChromate
      suggestedRBSale
      finalRBSale
      processPSuggestedPrice
      finalPSalePrice
      SQFTPPrice
      finalPSQFTPrice
      PPAPLevel
      aPPAPSubmission
      aSpecRessumission
      exsistingFamilly
      pointsToQuality
      qualityNotes
      costoPintura
      autorizado
      documentoAceptacion
      comentariosDeRechazo
      image
      documento1
      documento2
      documento3
      documento4
      documento5
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCotizacions = /* GraphQL */ `
  query ListCotizacions(
    $filter: ModelCotizacionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCotizacions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        CotizacionPadreID
        numero
        quoteNumber
        divisa
        date
        status
        fechaCreado
        fechaAutorizado
        fechaEnviado
        fechaEsperando
        fechaAceptado
        fechaRechazado
        generator
        revision
        processEngineering
        platingProcess
        clienteID
        cliente
        clienteCatalogo
        clienteNContacto
        productoCreado
        productoID
        address
        colonia
        ciudad
        estado
        pais
        codigoPostal
        telefono
        correo
        requestor
        position
        desk
        mobile
        email
        automotive
        OEM
        RFQNumber
        numerodeParte
        descripcion
        nickName
        annualVolume
        packigType
        packingINumber
        packingIRevision
        packingSource
        sampleReceived
        drawingSProvided
        drawingRevision
        paintThickness
        paintSpec
        zincPlating
        chromateColor
        previousProcess
        whiteCRequirement
        RedCRequiremen
        SOP
        EOP
        area
        pieceWeight
        printNotes
        salesNotes
        hangingTool
        asignedToolBar
        rackType
        piecesperBar
        barsPerLevel
        levels
        piecesPerRack
        weightForRack
        totalPerRack
        toolingCost
        maximumPieces
        newToolRequired
        costOfNewTool
        totalWeightRack
        asignedVoltage
        suggestedRack
        processSuggestedPrice
        finalRackSale
        finalSalePrice
        finalSQFTPrice
        typeOfProcess
        hangingToolP
        firstRowDistance
        tPiecesPROB
        pPerlevel
        lPerRack
        toolAngle
        toolingCostP
        SQTFPerBR
        loadWeightK
        DCVoltageA
        DCAmperageA
        residenceTimeZinc
        residenceTimeChromate
        suggestedRBSale
        finalRBSale
        processPSuggestedPrice
        finalPSalePrice
        SQFTPPrice
        finalPSQFTPrice
        PPAPLevel
        aPPAPSubmission
        aSpecRessumission
        exsistingFamilly
        pointsToQuality
        qualityNotes
        costoPintura
        autorizado
        documentoAceptacion
        comentariosDeRechazo
        image
        documento1
        documento2
        documento3
        documento4
        documento5
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCotizacionArea = /* GraphQL */ `
  query GetCotizacionArea($id: ID!) {
    getCotizacionArea(id: $id) {
      id
      numero
      idCotizacion
      medidaIngresadaEn
      alto
      ancho
      repeticiones
      orden
      medidaGrosor
      costoPintura
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCotizacionAreas = /* GraphQL */ `
  query ListCotizacionAreas(
    $filter: ModelCotizacionAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCotizacionAreas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        numero
        idCotizacion
        medidaIngresadaEn
        alto
        ancho
        repeticiones
        orden
        medidaGrosor
        costoPintura
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmbarqueUltimoNumero = /* GraphQL */ `
  query GetEmbarqueUltimoNumero($id: ID!) {
    getEmbarqueUltimoNumero(id: $id) {
      id
      numero
      numeroRobetS
      UltimoNumeroSerial
      numeroFacturaGeneral
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmbarqueUltimoNumeros = /* GraphQL */ `
  query ListEmbarqueUltimoNumeros(
    $filter: ModelEmbarqueUltimoNumeroFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmbarqueUltimoNumeros(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        numero
        numeroRobetS
        UltimoNumeroSerial
        numeroFacturaGeneral
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPProduccionUltimoNumero = /* GraphQL */ `
  query GetPProduccionUltimoNumero($id: ID!) {
    getPProduccionUltimoNumero(id: $id) {
      id
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPProduccionUltimoNumeros = /* GraphQL */ `
  query ListPProduccionUltimoNumeros(
    $filter: ModelPProduccionUltimoNumeroFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPProduccionUltimoNumeros(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        numero
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPlaneacionBaseUltimoNumero = /* GraphQL */ `
  query GetPlaneacionBaseUltimoNumero($id: ID!) {
    getPlaneacionBaseUltimoNumero(id: $id) {
      id
      fechaDePlaneacion
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPlaneacionBaseUltimoNumeros = /* GraphQL */ `
  query ListPlaneacionBaseUltimoNumeros(
    $filter: ModelPlaneacionBaseUltimoNumeroFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlaneacionBaseUltimoNumeros(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fechaDePlaneacion
        numero
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPlaneacionUltimoNumero = /* GraphQL */ `
  query GetPlaneacionUltimoNumero($id: ID!) {
    getPlaneacionUltimoNumero(id: $id) {
      id
      fechaDePlaneacion
      numero
      horasProduccion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPlaneacionUltimoNumeros = /* GraphQL */ `
  query ListPlaneacionUltimoNumeros(
    $filter: ModelPlaneacionUltimoNumeroFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlaneacionUltimoNumeros(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fechaDePlaneacion
        numero
        horasProduccion
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRecibaUltimoNumero = /* GraphQL */ `
  query GetRecibaUltimoNumero($id: ID!) {
    getRecibaUltimoNumero(id: $id) {
      id
      numero
      serialRecibaBTI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRecibaUltimoNumeros = /* GraphQL */ `
  query ListRecibaUltimoNumeros(
    $filter: ModelRecibaUltimoNumeroFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecibaUltimoNumeros(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        numero
        serialRecibaBTI
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCotizacionUltimoNumero = /* GraphQL */ `
  query GetCotizacionUltimoNumero($id: ID!) {
    getCotizacionUltimoNumero(id: $id) {
      id
      fecha
      numero
      quoteNumber
      costoPintura
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCotizacionUltimoNumeros = /* GraphQL */ `
  query ListCotizacionUltimoNumeros(
    $filter: ModelCotizacionUltimoNumeroFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCotizacionUltimoNumeros(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fecha
        numero
        quoteNumber
        costoPintura
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTicketUltimoNumero = /* GraphQL */ `
  query GetTicketUltimoNumero($id: ID!) {
    getTicketUltimoNumero(id: $id) {
      id
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTicketUltimoNumeros = /* GraphQL */ `
  query ListTicketUltimoNumeros(
    $filter: ModelTicketUltimoNumeroFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTicketUltimoNumeros(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        numero
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUsuarios = /* GraphQL */ `
  query GetUsuarios($id: ID!) {
    getUsuarios(id: $id) {
      id
      usuario
      nombreCompleto
      correo
      Almacen
      AlmacenDInventario
      Administrar
      Cotizaciones
      CotizacionesAutorizar
      Cuarentena
      Incoming
      IncomingDescarga
      Clientes
      Planeacion
      verPlaneacion
      verPlaneacionBase
      AgregarComentariosPPB
      Productos
      Reciba
      ModificarCantidadR
      RecibaDescargar
      PProduccion
      Produccion
      ProduccionInspeccion
      ProduccionCalidad
      ProduccionRecuperacion
      ProduccionCargaManual
      ModificarCantidadesAR
      PlaneacionSinFIFO
      PlaneacionAutNoFIFO
      PProduccionAutNoFIFO1
      PProduccionAutNoFIFO2
      InspeccionUnicaCalidad
      AutorizarTodo
      AutorizarCalidad
      AutorizarEmbarques
      ResumenOperacionVer
      ResumenOperacionEDefectos
      ResumenOperacionEPLaboratorio
      ResumenOperacionEAusentismoP
      ResumenOperacionEDatosExtra
      ProduccionReporteSema
      verPlanProduccion
      Embarques
      verEmbarques
      EmbarquesDInventario
      Ubicacion
      Facturacion
      Metricas
      MarcarFueradePlanta
      MarcarEmbarcadoAlmacen
      MarcarEmbarcadoEmbarques
      PaginaInicial
      AgregarProvedores
      AutorizarProvedores
      Compras
      LevantarRequisicion
      AutorizarRequisicion
      AutorizarCompra
      VerPrecioUnitario
      GestionarUbicacion
      TicketsUsuarios
      TicketsSoporte
      TicketsAuditor
      Notificaciones
      Usuarios
      perfil
      image
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsuarios = /* GraphQL */ `
  query ListUsuarios(
    $filter: ModelUsuariosFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsuarios(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        usuario
        nombreCompleto
        correo
        Almacen
        AlmacenDInventario
        Administrar
        Cotizaciones
        CotizacionesAutorizar
        Cuarentena
        Incoming
        IncomingDescarga
        Clientes
        Planeacion
        verPlaneacion
        verPlaneacionBase
        AgregarComentariosPPB
        Productos
        Reciba
        ModificarCantidadR
        RecibaDescargar
        PProduccion
        Produccion
        ProduccionInspeccion
        ProduccionCalidad
        ProduccionRecuperacion
        ProduccionCargaManual
        ModificarCantidadesAR
        PlaneacionSinFIFO
        PlaneacionAutNoFIFO
        PProduccionAutNoFIFO1
        PProduccionAutNoFIFO2
        InspeccionUnicaCalidad
        AutorizarTodo
        AutorizarCalidad
        AutorizarEmbarques
        ResumenOperacionVer
        ResumenOperacionEDefectos
        ResumenOperacionEPLaboratorio
        ResumenOperacionEAusentismoP
        ResumenOperacionEDatosExtra
        ProduccionReporteSema
        verPlanProduccion
        Embarques
        verEmbarques
        EmbarquesDInventario
        Ubicacion
        Facturacion
        Metricas
        MarcarFueradePlanta
        MarcarEmbarcadoAlmacen
        MarcarEmbarcadoEmbarques
        PaginaInicial
        AgregarProvedores
        AutorizarProvedores
        Compras
        LevantarRequisicion
        AutorizarRequisicion
        AutorizarCompra
        VerPrecioUnitario
        GestionarUbicacion
        TicketsUsuarios
        TicketsSoporte
        TicketsAuditor
        Notificaciones
        Usuarios
        perfil
        image
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLocacion = /* GraphQL */ `
  query GetLocacion($id: ID!) {
    getLocacion(id: $id) {
      id
      locacion
      espacio
      espacioOcupado
      ocupado
      recibaSerialID
      recibaSerialMPID
      fechaDeOcupacion
      fechaDeliberacion
      orden
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLocacions = /* GraphQL */ `
  query ListLocacions(
    $filter: ModelLocacionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocacions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        locacion
        espacio
        espacioOcupado
        ocupado
        recibaSerialID
        recibaSerialMPID
        fechaDeOcupacion
        fechaDeliberacion
        orden
        activo
        Reg_Ins_Usuario
        Reg_Mod_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCambios = /* GraphQL */ `
  query GetCambios($id: ID!) {
    getCambios(id: $id) {
      id
      tabla
      valorAnterior
      valorActual
      Reg_Ins_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCambios = /* GraphQL */ `
  query ListCambios(
    $filter: ModelCambiosFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCambios(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tabla
        valorAnterior
        valorActual
        Reg_Ins_Usuario
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
